import axios from 'axios'
import { Host } from '../data-models/host'
import { Store } from '../store'

const backendUrl = process.env.VUE_APP_BACKEND

export default {
  computed: {
    loggedIn () {
      return Store.host.name !== null && Store.host.id !== null
    },
    isAdmin () {
      return Store.host.isAdmin
    }
  }
}

export function fetchLoggedInHost () {
  return new Promise(resolve => {
    axios.get(backendUrl + '/auth/current')
      .then(response => resolve(new Host(response.data)))
      .catch(e => resolve({}))
  })
}

export function tryLogin (username, password) {
  return new Promise((resolve, reject) => {
    axios.post(backendUrl + '/auth/login', {
      username: username,
      password: password
    })
      .then(response => {
        // Our backend sends a 200 with body { error: ... } for invalid credentials.
        // Successful login should have a username and an id attached.
        const data = response.data

        if (data.error || !(data.id && data.username)) {
          reject(data)
        } else {
          resolve(new Host(data))
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function clearSession () {
  return new Promise((resolve) => {
    axios.get(backendUrl + '/auth/logout')
      .then(resolve())
  })
}

export function enforceAuth (to, from, next) {
  next(vm => {
    const redirectLoggedIn = to.path === '/' && vm.loggedIn
    const notLoggedIn = to.meta.mustBeLoggedIn === true && !vm.loggedIn
    const notAdmin = to.meta.mustBeAdmin === true && !vm.isAdmin

    if (notLoggedIn || notAdmin) {
      next('/', {
        replace: true
      })
    } else if (redirectLoggedIn) {
      next('/home', {
        replace: true
      })
    } else {
      next()
    }
  })
}
